var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpContentType, HttpStatusCode } from '../enums';
import { DocumentDownloadHelper } from './DocumentDownloadHelper';
export function handleResponse(response, preprocessor) {
    return __awaiter(this, void 0, void 0, function* () {
        return validateResponse(response)
            .then(response => (preprocessor ? preprocessor(response) : response))
            .then(response => resolveResponse(response))
            .then(response => {
            return response;
        });
    });
}
export function handleResponseWithExplicitErrorMessage(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return resolveResponse(response).then(data => {
            return response.ok ? data : Promise.reject(constructErrorResponse(data, response));
        });
    });
}
export function handleBlobWithErrorResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return response.blob().then(blob => {
            return response.ok ? blob : Promise.reject(response);
        });
    });
}
export function handleDownloadBlobWithErrorResponse(response, fileName, extension) {
    return __awaiter(this, void 0, void 0, function* () {
        return response.blob().then(blob => {
            return response.ok
                ? DocumentDownloadHelper.downloadDocument(blob, `${fileName}.${extension}`)
                : Promise.reject(response);
        });
    });
}
export function handlePdfBlobResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return response.blob().then(blob => {
            return response.ok ? new Blob([blob], { type: HttpContentType.APPLICATION_PDF }) : Promise.reject(response);
        });
    });
}
export function handleResponsePdf(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return response.blob().then(blob => {
            return response.ok ? blob : Promise.reject(stringifyErrorResponse(response));
        });
    });
}
/**
 * Processes non-JSON response received from fetch
 * @param response non-JSON response to process
 */
export function handleResponseText(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return response.text().then(text => {
            return response.ok ? text : Promise.reject(stringifyErrorResponse(response));
        });
    });
}
export function handleResponseNoContent(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return response.status === HttpStatusCode.NoContent ? response : Promise.reject(stringifyErrorResponse(response));
    });
}
export function stringifyErrorResponse(response) {
    return `${response.status} : ${response.statusText}`;
}
/**
 * Resolves the response from fetch call to the expected type.
 * If the response body cannot be parsed to JSON, it returns a rejected promise with the error details.
 * @param response The response object received from the fetch call.
 * @returns A promise that resolves to the expected type T if the response body is successfully parsed,
 * or rejects with an error message if parsing fails.
 */
export function resolveResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const text = yield response.text();
        try {
            const data = text && JSON.parse(text);
            return data;
        }
        catch (_a) {
            return Promise.reject(constructErrorFromTextResponse(text, response));
        }
    });
}
function validateResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return response.ok ? response : Promise.reject(stringifyErrorResponse(response));
    });
}
function constructErrorResponse(data, response) {
    const errorCodesString = `{ "Error":"${data['ErrorCode']}","ErrorDescription": "${data['ErrorDescription']}", "StatusCode" :"${response.status}", "StatusCodeDescription": "${response.statusText}"}`;
    return errorCodesString;
}
const constructErrorFromTextResponse = (text, response) => {
    return `{ "Error":"${encodeURIComponent(JSON.stringify(text))}", "StatusCode" :"${response.status}", "StatusCodeDescription": "${response.statusText}"}`;
};
export function handleResponseURL(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return validateResponse(response).then(validResponse => validResponse.url);
    });
}
//# sourceMappingURL=FetchWrapperHelper.js.map